import React, { useState } from "react";
import { Image, Button, Icon, Confirm, Modal } from "semantic-ui-react"; // <-- Importa Modal
import { image } from "../../../../assets";
import { InstitutionApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useTranslation } from "react-i18next";
import "./InstitutionItem.scss";

const institutionController = new InstitutionApi();

export function InstitutionItem(props) {
  const { institution, onReload, onEdit } = props;
  const { accessToken } = useAuth();
  const { t } = useTranslation("institutions");

  // Para el Confirm de activar/desactivar
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  // Para mostrar un Modal de error si el backend retorna un mensaje tipo "No tiene activaciones..."
  const [errorActivation, setErrorActivation] = useState(""); // Mensaje de error

  // Cierra el confirm
  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  // Cierra el modal de error
  const closeErrorModal = () => setErrorActivation("");

  // Cuando presionas el botón "Editar"
  const onOpenUpdate = () => {
    onEdit(institution);
  };

  // Al hacer click en el botón para (des)activar, definimos el mensaje en el confirm
  const openDeactivateActivateConfirm = () => {
    setConfirmMessage(
      institution.active
        ? `${t("item.deactivateConfirm")} ${institution.institutionnam}`
        : `${t("item.activateConfirm")} ${institution.institutionnam}`,
    );
    onOpenCloseConfirm();
  };

  // Aquí llamamos al endpoint de toggleInstitutionActivation
  const onActivateDeactivate = async () => {
    try {
      const newActive = !institution.active;
      await institutionController.toggleInstitutionActivation(
        accessToken,
        institution._id,
        newActive,
      );
      // Si todo va bien, refrescamos la lista
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error("Error al cambiar el estado de la institución:", error);
      // Si el backend envía un mensaje tipo "No tiene activaciones disponibles", aquí lo capturamos.
      // Guardamos ese mensaje en el state 'errorActivation' para mostrarlo en un Modal.
      setErrorActivation(error.message || t("item.activationError"));
      // OJO: No hacemos onReload() ni cerramos el confirm, así la institución permanece con su estado anterior.
    }
  };

  return (
    <>
      {institution.active ? (
        // ====================== INSTITUCIÓN ACTIVA ======================
        <div className="institution-item">
          <div className="institution-item__image">
            <img
              src={institution.avatar ? institution.avatar : image.noAvatar}
              alt={institution.institutionnam}
              loading="lazy"
            />
          </div>
          <div className="institution-item__content">
            <h2>{institution.institutionnam}</h2>
            <p>
              {t("item.addressLabel")}: {institution.address}
            </p>
            <p>
              {t("item.phoneLabel")}: {institution.phone}
            </p>
            <p>
              {t("item.contactLabel")}: {institution.firstname}{" "}
              {institution.lastname}
            </p>
            <p>
              {t("item.emailLabel")}: {institution.email}
            </p>
            <p>
              {t("item.planLabel")}: {institution.planEduca?.title}
            </p>
            <p>
              {t("item.licenseLabel")}: {institution.planEduca?.account}
            </p>
            <p>
              {t("item.expiresLabel")}:{" "}
              {institution.expired_at
                ? institution.expired_at.split("T")[0]
                : "N/A"}
            </p>
            <p>
              {t("item.studentsLabel")}: {institution.studentsnum}
            </p>
            <p>
              {t("item.teachersLabel")}: {institution.teachersnum}
            </p>
            <p>{institution.website}</p>

            <img
              src={
                institution.planEduca?.miniature
                  ? institution.planEduca.miniature
                  : image.noAvatar
              }
              alt={institution.planEduca?.title}
              loading="lazy"
            />

            <div className="institution-item__buttons">
              {/* Ver web */}
              <Button icon as="a" href={institution.website} target="_blank">
                <Icon name="eye" />
              </Button>
              {/* Editar */}
              <Button icon primary onClick={onOpenUpdate}>
                <Icon name="pencil" />
              </Button>
              {/* Desactivar */}
              <Button
                icon
                color="orange"
                onClick={openDeactivateActivateConfirm}
              >
                <Icon name="ban" />
              </Button>
            </div>
          </div>
        </div>
      ) : (
        // ====================== INSTITUCIÓN INACTIVA ======================
        <div className="institution-item institution-item--inactive">
          <div className="institution-item__info">
            <Image
              avatar
              src={institution.avatar ? institution.avatar : image.noAvatar}
            />
            <div>
              <p>
                {institution.firstname} {institution.lastname}
              </p>
              <p>{institution.email}</p>
            </div>
          </div>
          <div>
            {/* Editar */}
            <Button icon primary onClick={onOpenUpdate}>
              <Icon name="pencil" />
            </Button>
            {/* Activar */}
            <Button icon color="teal" onClick={openDeactivateActivateConfirm}>
              <Icon name="check" />
            </Button>
          </div>
        </div>
      )}

      {/* Confirm para activar/desactivar */}
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onActivateDeactivate}
        content={confirmMessage}
        size="mini"
      />

      {/* Modal para mostrar error si no hay activaciones disponibles (u otro error) */}
      <Modal open={!!errorActivation} onClose={closeErrorModal} size="mini">
        <Modal.Header>{t("item.errorTitle")}</Modal.Header>
        <Modal.Content>
          <p>{errorActivation}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeErrorModal} color="red">
            {t("item.closeButton")}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
